import "./ProfileDropdownComponent.scss";
import {ImageConfig} from "../../../../constants";
import {useDispatch, useSelector} from "react-redux";
import {IRootReducerState} from "../../../../store/reducers";
import {CommonService} from "../../../services";
import MenuDropdownComponent from "../../menu-dropdown/MenuDropdownComponent";
import React, {useCallback, useState} from "react";
import {useNavigate} from "react-router-dom";
import {logout, setLoggedInUserData, setLoggedInUserToken} from "../../../../store/actions/account.action";
import AvatarComponent from "../../avatar/AvatarComponent";
import {IAPIResponseType} from "../../../models/api.model";
import ButtonComponent from "../../button/ButtonComponent";
import DrawerComponent from "../../drawer/DrawerComponent";
import ClientDetailsFormComponent from "../../../../screens/client-details-form/ClientDetailsFormComponent";

interface ProfileDropdownComponentProps {

}

const ProfileDropdownComponent = (props: ProfileDropdownComponentProps) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {currentUser} = useSelector((state: IRootReducerState) => state.account);
    const {accessibleAccounts} = useSelector((state: IRootReducerState) => state.staticData);
    const [isClientDetailsFormDrawerOpen, setIsClientDetailsFormDrawerOpen] = useState<boolean>(false);

    const handleOpenClientFormDrawer = useCallback(() => {
        setIsClientDetailsFormDrawerOpen(true)
    }, []);

    const handleLogout = useCallback(() => {
        CommonService.onConfirm({
            showLottie: false,
            image: ImageConfig.LogoutPopupIcon,
            confirmationSubTitle: "Are you sure you want to logout?",
            yes: {
                text: "Logout",
            },
            no: {
                text: "Cancel",
            }
        }).then(() => {
            dispatch(logout());
            navigate(CommonService._routeConfig.LoginRoute());
        }).catch((error: Error) => {
            CommonService._alert.showToast(error.message, "error");
        })

    }, [dispatch, navigate]);

    const switchProfile = useCallback((profileId: string) => {
        const payload = {}
        CommonService._account.switchProfile(profileId, payload)
            .then((response: IAPIResponseType<any>) => {
                window.location.href = CommonService._routeConfig.Dashboard();
                dispatch(setLoggedInUserData(response?.data?.user));
                dispatch(setLoggedInUserToken(response?.data?.token));
            })
            .catch((error: any) => {
                CommonService._alert.showToast(error.error, "error");
            });
    }, [dispatch])

    const navigateToProfileDetails = useCallback(() => {
        navigate(CommonService._routeConfig.ProfileLayout());
    }, [navigate]);


    return (
        <div className={'profile-dropdown profile-dropdown-component'}>
            <MenuDropdownComponent
                menuBase={<div className="profile-dropdown__wrapper">
                    <ImageConfig.ProfileIcon className="profile-dropdown__profile-icon"/>
                    <div className="profile-dropdown__name">
                        {currentUser?.first_name + " " + currentUser?.last_name}
                    </div>
                    <div className="profile-dropdown__arrow-icon">
                        <ImageConfig.SelectDropDownIcon />
                    </div>
                </div>}
            >
                <div className="profile-dropdown__menu-item" onClick={navigateToProfileDetails}>
                    <div className="profile-dropdown__menu-item__icon">
                        <ImageConfig.PersonIcon height={24} width={24}/>
                    </div>
                    <div className="profile-dropdown__menu-item__label">
                        <div>
                            Account Settings
                        </div><br/>
                        <div className={'client-id'}>ID: {currentUser?.client_id} </div>
                    </div>
                </div>

                <div className="profile-dropdown__menu-item"
                     onClick={handleOpenClientFormDrawer}>
                    <div className="profile-dropdown__menu-item__icon">
                        <ImageConfig.AddIcon/>
                    </div>
                    <div className="profile-dropdown__menu-item__label">
                        &nbsp;Add New Client
                    </div>
                </div>
                <div className="profile-dropdown__menu-item-separator"/>
                {accessibleAccounts.length > 0 && <>
                    <div className="profile-dropdown__menu-item-sub-header">Linked Profiles</div>
                    {
                        accessibleAccounts.map((account: any) => {
                            return (
                                <div className="profile-dropdown__menu-item" key={account.id}
                                     onClick={() => switchProfile(account.client_details._id)}>
                                    <div className="profile-dropdown__menu-item__icon">
                                        <AvatarComponent size={'sm'}
                                                         title={account?.client_details?.first_name + " " + account?.client_details?.last_name}/>
                                    </div>
                                    <div className="profile-dropdown__menu-account-item">
                                        <div
                                            className="profile-dropdown__menu-account-name">{account?.client_details?.first_name + " " + account?.client_details?.last_name}</div>
                                        <div
                                            className="profile-dropdown__menu-account-relation">{CommonService.capitalizeFirstLetter(account?.relationship)}</div>
                                    </div>
                                </div>
                            );
                        })
                    }
                    <ButtonComponent size={'small'}
                                     prefixIcon={<ImageConfig.LinkIcon/>}
                                     className={'profile-dropdown__menu-item-link-btn'}
                                     onClick={() => navigate(CommonService._routeConfig.ProfileLinking())}
                                     variant={'outlined'} color={'accent'}>Link/Unlink Profile</ButtonComponent>
                    {!accessibleAccounts.length && <div className="profile-dropdown__menu-item-separator"/>}
                </>
                }

                <div className="profile-dropdown__menu-item-separator"/>
                <div className="profile-dropdown__menu-item-logout" onClick={handleLogout}>
                    <div className="profile-dropdown__menu-item__icon">
                        <ImageConfig.LogoutIcon/>
                    </div>
                    <div className="profile-dropdown__menu-item__label">
                        &nbsp;Logout
                    </div>
                </div>
            </MenuDropdownComponent>
            <DrawerComponent isOpen={isClientDetailsFormDrawerOpen}
                             closeOnEsc={false}
                             hideBackdrop={false}
                             showClose={true}
                             onClose={() => setIsClientDetailsFormDrawerOpen(false)}
                             direction={"right"}>
                <ClientDetailsFormComponent setIsClientDetailsFormDrawerOpen={setIsClientDetailsFormDrawerOpen}/>
            </DrawerComponent>
        </div>
    );

};

export default ProfileDropdownComponent;
